var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",class:_vm.$style.wrapper,style:(_vm.style)},[_c('div',{class:_vm.$style.toggle,on:{"click":_vm.animate}},[_c('font-awesome-icon',{class:_vm.$style.toggleIcon,attrs:{"icon":_vm.icon}})],1),_c('div',{ref:"content",class:_vm.$style.content,domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }